module.exports = __webpack_public_path__ + "img/b_3.f0d218c6.jpg";